import apiClient from "./api";

export type AgentType =
  | "Support"
  | "Copilot"
  | "Analytics"
  | "General"
  | "Custom";

export interface Agent {
  id: string;
  widgetId: string;
  name: string;
  type: AgentType;
  toneOfVoice?: string;
  behaviorInstructions?: string;
  brandingInstructions?: string;
  customInstructions?: string;
  toolsPolicy: number;
  kbPolicy: number;
}

export interface UpdateAgentRequest {
  toneOfVoice?: string;
  behaviorInstructions?: string;
  brandingInstructions?: string;
  customInstructions?: string;
}

export interface BulkUpdateAgentsRequest {
  toneOfVoice?: string;
  behaviorInstructions?: string;
  brandingInstructions?: string;
  customInstructions: Record<string, string | null>;
}

export const agentService = {
  getAgents: (widgetId: string): Promise<Agent[]> =>
    apiClient.get(`/widget/${widgetId}/agents`).then((r) => r.data),

  updateAgent: (
    widgetId: string,
    agentId: string,
    data: UpdateAgentRequest,
  ): Promise<Agent> =>
    apiClient
      .put(`/widget/${widgetId}/agents/${agentId}`, data)
      .then((r) => r.data),

  bulkUpdateAgents: (
    widgetId: string,
    data: BulkUpdateAgentsRequest,
  ): Promise<Agent[]> =>
    apiClient.put(`/widget/${widgetId}/agents`, data).then((r) => r.data),

  initializeAgents: (widgetId: string): Promise<Agent[]> =>
    apiClient.post(`/widget/${widgetId}/agents/initialize`).then((r) => r.data),
};
